import React from 'react';
import { Lock, Download, Star } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1C1917] text-stone-400 py-12 border-t border-white/10" data-id="element-23">
      <div className="max-w-5xl mx-auto px-6" data-id="element-24">
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-8 pb-8 border-b border-white/10" data-id="element-25">
          <div className="flex items-center gap-2" data-id="element-26">
            <Lock className="w-5 h-5 text-[#C5A059]" data-id="element-27" />
            <span className="text-sm font-medium" data-id="element-28">Compra 100% Segura</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-29">
            <Download className="w-5 h-5 text-[#C5A059]" data-id="element-30" />
            <span className="text-sm font-medium" data-id="element-31">Entrega en 2 minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-32">
            <Star className="w-5 h-5 text-[#C5A059]" data-id="element-33" />
            <span className="text-sm font-medium" data-id="element-34">Garantía de Calidad</span>
          </div>
        </div>

        <div className="text-center text-xs space-y-2" data-id="element-35">
          <p data-id="element-36">
            © {new Date().getFullYear()} El Código Invisible del Dinero. Todos
            los derechos reservados.
          </p>
          <p className="opacity-60" data-id="element-37">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}